import { CanActivateFn } from '@angular/router';
import { keycloak } from './keycloak';

export const authGuard: CanActivateFn = async () => {
  return !!keycloak.authenticated;
};
